import { useState, useEffect, React } from 'react';
import { useSearchParams } from 'react-router-dom';

import QueryPageTemplate from 'src/pages/QueryPages/components/QueryPageTemplate';
import StatusToggle from 'src/pages/QueryPages/components/StatusToggle';
import { PATHS } from 'src/constants/config';

const PitchInbox = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedStatus, setSelectedStatus] = useState('new');

  // Initialize status from URL params
  useEffect(() => {
    const statusParam = searchParams.get('status');
    if (statusParam && ['new', 'pending', 'pitchInbox'].includes(statusParam)) {
      setSelectedStatus(statusParam);
    } else if (!statusParam) {
      // No status param means we're on the default "new" tab
      setSelectedStatus('new');
    }
  }, [searchParams]);

  const handleStatusChange = (newStatus) => {
    setSelectedStatus(newStatus);
    const newParams = new URLSearchParams(searchParams);
    if (newStatus === 'new') {
      newParams.delete('status');
    } else {
      newParams.set('status', newStatus);
    }
    // Remove page parameter when switching status to start from page 1
    newParams.delete('page');
    setSearchParams(newParams);
  };

  const getQueryStatuses = (status) => {
    switch (status) {
      case 'new':
        return ['new'];
      case 'pending':
        return ['pending', 'submittedToJournalist', 'pendingPublication'];
      case 'pitchInbox':
        return ['draft', 'awaiting', 'clientApproved', 'clientNeedsEdits', 'needsFollowUp', 'inquireInterest', 'interviewOpportunity'];
      default:
        return ['new'];
    }
  };

  const getTitle = (status) => {
    switch (status) {
      case 'new':
        return 'Queries';
      case 'pitchInbox':
        return 'Inbox';
      case 'pending':
        return 'Submitted';
      default:
        return 'Queries';
    }
  };

  const getPageType = (status) => {
    switch (status) {
      case 'new':
        return 'new';
      case 'pending':
        return 'submitted';
      case 'pitchInbox':
        return 'pitchInbox';
      default:
        return 'new';
    }
  };

  return (
    <QueryPageTemplate
      queryStatuses={getQueryStatuses(selectedStatus)}
      title={getTitle(selectedStatus)}
      path={PATHS.PITCH_INBOX.value}
      pageType={getPageType(selectedStatus)}
      showDeadline={selectedStatus !== 'pending'}
      headerSlot={<StatusToggle selectedStatus={selectedStatus} onStatusChange={handleStatusChange} />}
    />
  );
};

export default PitchInbox;
